import React from 'react';

interface AnchorProps {
  href: string;
  text: string;
}

const Anchor: React.FC<AnchorProps> = ({ href, text }) => {
  return (
    <a href={href} target="_blank" rel="noreferrer">
      {text}
    </a>
  );
};

export default Anchor;
